// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"defs","attrs":{},"children":[{"tag":"mask","attrs":{"id":"props.overlapMaskId_fill1","maskUnits":"userSpaceOnUse","maskContentUnits":"userSpaceOnUse","mask-type":"luminance","x":"0","y":"0","width":"24","height":"24"},"children":[{"tag":"rect","attrs":{"x":"0","y":"0","width":"24","height":"24","fill":"#fff"}},{"tag":"path","attrs":{"stroke":"#000","d":"M12 15V12M5 15V22H19V15H5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth","fill":"none"}}]}]},{"tag":"g","attrs":{"id":"router-wave"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M5 15H19V22H5V15Z","mask":"props.overlapMaskUrl_fill1"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12 15V12M5 15V22H19V15H5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M2.73633 7.07193C4.69159 4.02153 8.11167 2 12.0039 2C15.8961 2 19.3162 4.02153 21.2715 7.07193M6.9375 8.75479C8.00401 7.09093 9.8695 5.98828 11.9925 5.98828C14.1156 5.98828 15.9811 7.09093 17.0476 8.75479","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const RouterWaveIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'router-wave',
    ref,
    icon: element,
  },
));

RouterWaveIcon.displayName = 'RouterWaveIcon';

export default RouterWaveIcon;
